export const WEBHOOK_URL = 'WEBHOOK_URL_PLACEHOLDER';
